export const faqData = [
  {
    question: "Was ist die HTWKarte?",
    answer:
      "Die HTWKarte visualisiert alle von der HTWK genutzten Gebäude mit ihren Räumen und ermöglicht den Nutzern schnell ihre Räume zu finden. Das Projekt wird von Studierenden für Studierende entwickelt.",
  },
  {
    question: "Was kann ich derzeit suchen?",
    answer:
      "Die Suchleiste ermöglicht derzeit entweder die direkte Suche nach einem Raum oder die Suche nach dem Büro einer Person. Wird direkt nach einem Raum gesucht ist darauf zu achten das richtige Format zu wählen: BBERR (BB: Gebäudekürzel, E: Etage, RR: Raumnummer).",
  },
  {
    question: "Ich habe einen Fehler/Inkonsistenz gefunden, was kann ich tun?",
    answer: "Wir sind immer dankbar für Tipps. Komm gerne auf uns zu über den Impressums-Bereich.",
  },
  {
    question:
      "Ich möchte ein Bild oder eine Beschreibung für einen Raum hinzufügen, wie mache ich das?",
    answer:
      "Es gibt zwei Möglichkeiten: Entweder du stellst eine Merge-Request auf GitLab im Repository HTWKarte-resources oder du schickt mir eine E-Mail an benedikt.beigang@stud.htwk-leipzig.de",
  },
  {
    question:
      "Ich habe Zugang zu schwer zugänglichen Bereichen, die interessant für bestimmte Studierende sein könnten (zB Brandschutzpläne von einer nicht öffentlich zugänglichen Etage)?",
    answer:
      "Wir sind immer auf der Suche nach neuen Datenquellen, da die vorhandenen Datenquellen oft veraltet oder manche Bereiche nur schwer zugänglich sind. Du kannst uns erreichen über die Angaben im Impressum.",
  },
  {
    question: "Wer steht hinter der HTWKarte?",
    answer:
      "Der Hauptentwickler ist Benedikt Beigang (INM), der das Projekt in Kooperation mit dem HTWKalender entwickelt. Perspektivisch sollen die Projekte zusammenarbeiten, sodass über Termine im HTWKalender direkt auf den Raum in diesem Termin gesprungen werden kann.",
  },
  {
    question: "Kann ich an der HTWKarte mitarbeiten?",
    answer: "Ja das geht! Das Repository ist auf dem GitLab-Server der HTWK Leipzig zu finden.",
  },
  {
    question: "Kann ich die App auch offline nutzen?",
    answer:
      "Ja dies ist möglich. Wenn du Google-Chrome verwendest kannst du die HTWKarte lokal installieren.",
  },
  {
    question: "Wie genau sind die Informationen und Pläne?",
    answer:
      "Wir können nicht für alle Angaben garantieren, geben uns aber viel Mühe die Realität so gut es geht abzubilden. Oft arbeiten wir mit veralteten Plänen und Informationen, wir versuchen aber immer wenn wir auf Fehler stoßen oder hingewiesen werden diese zu korrigieren.",
  },
];
